import { render, staticRenderFns } from "./LocaleSection.vue?vue&type=template&id=5f2855f2&scoped=true"
import script from "./LocaleSection.vue?vue&type=script&lang=js"
export * from "./LocaleSection.vue?vue&type=script&lang=js"
import style0 from "./LocaleSection.vue?vue&type=style&index=0&id=5f2855f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2855f2",
  null
  
)

export default component.exports